import React, { useState } from 'react'
import { SelectMulti } from '../../../../../../../../Components/CustomUi/SelectMulti'
import { Box } from '../../../../../../../../Components/CustomUi/box'
import { Select } from '../../../../../../../../Components/CustomUi/Select'
import { faDna, faLeaf, faVial } from '@fortawesome/free-solid-svg-icons'
import { dadosAcao } from '../../../../meta'

interface PropsFormPropriedade {
  dataCaldas: any[]
  dataPlantas: any[]
  caldasSelecionadas: { descr: string; id: number; key?: number }[]
  setCaldasSelecionadas: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  gotaSelecionadas: { descr: string; id: number; key?: number }[]
  setGotaSelecionadas: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  folhaSelecionadas: { descr: string; id: number; key?: number }[]
  setFolhaSelecionadas: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  dentroSelecionadas: { descr: string; id: number; key?: number }[]
  setDentroSelecionadas: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  acaoPhSelecionadas: string
  setAcaoPhSelecionadas: React.Dispatch<React.SetStateAction<string>>
  setAcaoPhSelecionadasId: React.Dispatch<React.SetStateAction<number>>
}

export const FormPropriedade: React.FC<PropsFormPropriedade> = ({
  dataCaldas,
  dataPlantas,
  caldasSelecionadas,
  setCaldasSelecionadas,
  gotaSelecionadas,
  setGotaSelecionadas,
  folhaSelecionadas,
  setFolhaSelecionadas,
  dentroSelecionadas,
  setDentroSelecionadas,
  acaoPhSelecionadas,
  setAcaoPhSelecionadas,
  setAcaoPhSelecionadasId,
}) => {
  const [openCalda, setOpenCalda] = useState<boolean>(false)
  const [openAcao, setOpenAcao] = useState<boolean>(false)
  const [openGota, setOpenGota] = useState<boolean>(false)
  const [openFolha, setOpenFolha] = useState<boolean>(false)
  const [openDentro, setOpenDentro] = useState<boolean>(false)

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <Box>
        <SelectMulti
          label='Na calda'
          placeholder='Selecione as propriedades na calda'
          open={openCalda}
          icon={faDna}
          trigger={setOpenCalda}
          items={dataCaldas}
          descricaoItem={'nome'}
          idItem={'cod'}
          selecteds={caldasSelecionadas}
          onChange={setCaldasSelecionadas}
        />
        <Select
          label='Ação do pH na calda'
          placeholder='Selecione a ação do pH na calda'
          open={openAcao}
          trigger={setOpenAcao}
          icon={faVial}
          items={dadosAcao}
          value={acaoPhSelecionadas}
          onChange={setAcaoPhSelecionadas}
          onChangeID={setAcaoPhSelecionadasId}
          descricaoItem={'nome'}
          idItem={'cod'}
        />
       
      </Box>
      <SelectMulti
        label='Trajeto da gota, folha e dentro da folha'
        placeholder='Selecione as propriedades do trajeto da gota, folha e dentro da folha'
        open={openGota}
        icon={faLeaf}
        trigger={setOpenGota}
        items={dataPlantas}
        descricaoItem={'nome'}
        idItem={'cod'}
        selecteds={gotaSelecionadas}
        onChange={setGotaSelecionadas}
      />
     
    </div>
  )
}